"use client";

import React from "react";
import { Instagram } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/jane_liam_engagement.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/jane_liam_engagement.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/jane_liam_engagement.png-wvc-sizes",
  alt: "Jane and Liam engagement portrait"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/wedding_venue_details.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/wedding_venue_details.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/wedding_venue_details.png-wvc-sizes",
  alt: "Elegant floral arrangements"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/couple_walking_park.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/couple_walking_park.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/couple_walking_park.png-wvc-sizes",
  alt: "Jane and Liam walking in the park"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/wedding_invitation_flatlay.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/wedding_invitation_flatlay.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/wedding_invitation_flatlay.png-wvc-sizes",
  alt: "Digital invitation preview"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/jane_liam_laughing.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/jane_liam_laughing.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/jane_liam_laughing.png-wvc-sizes",
  alt: "The couple sharing a laugh"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/ceremony_location_view.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/ceremony_location_view.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/ceremony_location_view.png-wvc-sizes",
  alt: "The beautiful ceremony location"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/wedding_rings_detail.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/wedding_rings_detail.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/wedding_rings_detail.png-wvc-sizes",
  alt: "Close up of wedding rings"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/jane_liam_sunset.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/jane_liam_sunset.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/jane_liam_sunset.png-wvc-sizes",
  alt: "Sunset silhouette of the couple"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/celebration_champagne.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/celebration_champagne.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678925/img/celebration_champagne.png-wvc-sizes",
  alt: "Champagne toast celebration"
}];
export default function MasonryGallery() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: galleryRef,
    isVisible: isGalleryVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="263917" id="moments-captured" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`flex flex-col md:flex-row justify-between items-start md:items-end mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <div className="max-w-2xl">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-light text-primary mb-6 tracking-tight italic">
              Moments Captured
            </h2>
            <p className="text-lg text-foreground/80 font-sans tracking-wide">
              A visual journey through Jane & Liam&apos;s love story. From quiet afternoons to the grand celebration of their union.
            </p>
          </div>
          
          <Button asChild variant="outline" size="lg" className="mt-8 md:mt-0 border-primary/30 text-primary hover:bg-secondary hover:text-secondary-foreground transition-colors duration-500 rounded-md font-sans text-xs tracking-widest uppercase">
            <Link to="https://instagram.com/janeandliam" newTab>
              <Instagram className="w-4 h-4 mr-2" />
              Follow Our Story
            </Link>
          </Button>
        </div>

        <div ref={galleryRef} className={`columns-1 sm:columns-2 md:columns-3 lg:columns-4 gap-6 space-y-6 transition-all duration-1000 delay-200 ease-out ${isGalleryVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {galleryImages.map((image, i) => <div key={i} data-index={i} className="relative group overflow-hidden rounded-md break-inside-avoid shadow-sm hover:shadow-xl transition-shadow duration-700 bg-muted">
              <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" className="w-full h-auto object-cover transition-transform duration-1000 ease-in-out group-hover:scale-105 grayscale-[20%] group-hover:grayscale-0" />
              
              <div className="absolute inset-0 bg-primary/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-center justify-center backdrop-blur-[1px]">
                <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                  <span className="text-primary-foreground font-sans text-xs tracking-widest uppercase bg-primary/80 px-4 py-2 rounded-md">View</span>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}